<template>
  <div id="cookie-notice" :class="['cookie-notice', dcn.position]" v-if="!is_cookie_set() && show" :style="{background: dcn.bg_color}">
    <div class="cookie-flex">
      <div class="cookie-message" :style="{color: dcn.fg_color}">
        {{dcn.cookie_message}}
        <div class="learn-more" v-if="can_redirect()"><a :href="redirect_link">{{dcn.redirect_text}}</a></div>
      </div>
      <div class="cookie-ok-button">
        <button :class='["btn-ok",dcn.button_style]' @click="ok()">Ok</button>
      </div>
      <div class="cookie-refuse" v-if="can_refuse()">
        <button :class='["btn-refuse", dcn.button_style]' @click="refuse()">{{dcn.refuse_text}}</button>
      </div>
      <div class="cookie-revoke" v-if="can_revoke()">
        <button :class='["btn-revoke", dcn.button_style]' @click="revoke()">{{dcn.revoke_text}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data (){
    return {
      dcn: {

      },
      cookie: '',
      show: true
    }
  },
  methods: {
    ok (){
      this.set_cookie('ok')
      this.show = false
      if(this.can_reload())
        window.location.reload()
    },
    refuse (){
      this.set_cookie('no')
      this.show = false
    },
    revoke (){
      this.set_cookie('revoke')
      this.show = false
    },
    can_reload (){
      if(this.dcn.reload == 1 || this.dcn.reload == '1')
        return true
      else
        return false
    },
    can_redirect (){
      if(this.dcn.redirect == 1 || this.dcn.redirect == '1')
        return true
      else
        return false
    },
    can_refuse (){
      if(this.dcn.refuse == 1 || this.dcn.refuse == '1')
        return true
      else
        return false
    },
    can_revoke (){
      if(this.dcn.revoke == 1 || this.dcn.revoke == '1')
        return true
      else
        return false
    },
    can_scroll (){
      if(this.dcn.scroll == 1 || this.dcn.scroll == '1')
        return true
      else
        return false
    },
    is_cookie_set (){
      var data = this.$cookie.get('dcn-cookie-notice-dodel')
      this.cookie = data
      if(data=='ok' || data=='no' || data=='revoke')
        return true
      else return false
    },
    expires (){
      switch(this.dcn.cookie_expiry){
        case 'hour': return '1h'; break;
        case 'day': return '1D'; break;
        case 'week': return '7D'; break;
        case 'month': return '1M'; break;
        case '3months': return '3M'; break;
        case '6months': return '6M'; break;
        case 'year': return '1Y';
        case 'infinity': return '999Y'; break;
        default: return '1D';
      }
    },
    set_cookie (data){
      this.cookie = data
      this.$cookie.set('dcn-cookie-notice-dodel', data, {expires: this.expires()})
    },
    handleScroll (){
      if(this.can_scroll()){
        var scrolled = window.pageYOffset || document.documentElement.scrollTop;
        if(parseInt(this.dcn.scroll_offset)<scrolled){
          this.dcn.reload = 0
          this.ok()
        }
      }

    }
  },
  computed: {
    redirect_link (){
      if(this.dcn.redirect_type == 'custom')
        return this.dcn.redirect_link
      else
        return this.dcn.redirect_page_id
    },
  }, 
  mounted (){
    this.dcn = window.dcn

    window.addEventListener('scroll', this.handleScroll);
  }
}
</script>

<style type="text/css" scoped>
  .cookie-notice{
    position: fixed;
    left: 0;
    right: 0;
    padding: 20px;
    font-size: 12px;
    font-family: Roboto, Helvetica, Arial, sans-serif;
  }
  .cookie-notice.top{
    top: 0;
  }
  .cookie-notice.bottom{
    bottom: 0;
  }
  .cookie-notice .cookie-flex{
    display: flex;
  }
  .cookie-notice .cookie-flex .cookie-ok-button, .cookie-notice .cookie-flex .cookie-refuse, .cookie-notice .cookie-flex .cookie-revoke{
    align-self: flex-end;
    margin-right: 10px;
    align-items: flex-start;
    align-content: flex-start;
  }
  .cookie-notice .cookie-message{
    margin-right: 20px;
  }
  .cookie-notice .btn-ok.none{
    font-weight: bold;
  }
  .cookie-notice .btn-ok.wordpress{
    display: inline-block;
    text-decoration: none;
    font-size: 13px;
    line-height: 23px;
    margin: 0;
    padding: 0 10px;
    cursor: pointer;
    border-width: 1px;
    border-style: solid;
    -webkit-border-radius: 3px;
    -webkit-appearance: none;
    border-radius: 3px;
    white-space: nowrap;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #21759b;
    background-image: -webkit-gradient(linear,left top,left bottom,from(#2a95c5),to(#21759b));
    background-image: -webkit-linear-gradient(top,#2a95c5,#21759b);
    background-image: -moz-linear-gradient(top,#2a95c5,#21759b);
    background-image: -ms-linear-gradient(top,#2a95c5,#21759b);
    background-image: -o-linear-gradient(top,#2a95c5,#21759b);
    background-image: linear-gradient(to bottom,#2a95c5,#21759b);
    border-color: #21759b;
    border-bottom-color: #1e6a8d;
    -webkit-box-shadow: inset 0 1px 0 rgba(120,200,230,0.5);
    box-shadow: inset 0 1px 0 rgba(120,200,230,0.5);
    color: #fff;
    text-decoration: none;
    text-shadow: 0 1px 0 rgba(0,0,0,0.1);
  }
  .cookie-notice .btn-ok.wordpress:hover{
    background-color: #278ab7;
    background-image: -webkit-gradient(linear,left top,left bottom,from(#2e9fd2),to(#21759b));
    background-image: -webkit-linear-gradient(top,#2e9fd2,#21759b);
    background-image: -moz-linear-gradient(top,#2e9fd2,#21759b);
    background-image: -ms-linear-gradient(top,#2e9fd2,#21759b);
    background-image: -o-linear-gradient(top,#2e9fd2,#21759b);
    background-image: linear-gradient(to bottom,#2e9fd2,#21759b);
    border-color: #1b607f;
    -webkit-box-shadow: inset 0 1px 0 rgba(120,200,230,0.6);
    box-shadow: inset 0 1px 0 rgba(120,200,230,0.6);
    color: #fff;
    text-shadow: 0 -1px 0 rgba(0,0,0,0.3);
  }
  .cookie-notice .btn-ok.bootstrap{
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
  }
  .cookie-notice .btn-ok.bootstrap:hover{
    color: #fff;
    background-color: #218838;
    border-color: #1e7e34;
  }
  .cookie-notice .btn-refuse.none{

  }
  .cookie-notice .btn-refuse.wordpress{
    display: inline-block;
    text-decoration: none;
    font-size: 13px;
    line-height: 23px;
    margin: 0;
    padding: 0 10px;
    cursor: pointer;
    border-width: 1px;
    border-style: solid;
    -webkit-border-radius: 3px;
    -webkit-appearance: none;
    border-radius: 3px;
    white-space: nowrap;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background: #f3f3f3;
    background-image: -webkit-gradient(linear,left top,left bottom,from(#fefefe),to(#f4f4f4));
    background-image: -webkit-linear-gradient(top,#fefefe,#f4f4f4);
    background-image: -moz-linear-gradient(top,#fefefe,#f4f4f4);
    background-image: -o-linear-gradient(top,#fefefe,#f4f4f4);
    background-image: linear-gradient(to bottom,#fefefe,#f4f4f4);
    border-color: #bbb;
    color: #333;
    text-shadow: 0 1px 0 #fff;
  }
  .cookie-notice .btn-refuse.wordpress:hover{
    background: #f3f3f3;
    background-image: -webkit-gradient(linear,left top,left bottom,from(#fff),to(#f3f3f3));
    background-image: -webkit-linear-gradient(top,#fff,#f3f3f3);
    background-image: -moz-linear-gradient(top,#fff,#f3f3f3);
    background-image: -ms-linear-gradient(top,#fff,#f3f3f3);
    background-image: -o-linear-gradient(top,#fff,#f3f3f3);
    background-image: linear-gradient(to bottom,#fff,#f3f3f3);
    border-color: #999;
    color: #222;
  }
  .cookie-notice .btn-refuse.bootstrap{
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107;
  }
  .cookie-notice .btn-refuse.bootstrap:hover{
    color: #212529;
    background-color: #e0a800;
    border-color: #d39e00;
  }
  .cookie-notice .btn-revoke.none{

  }
  .cookie-notice .btn-revoke.wordpress{
    display: inline-block;
    text-decoration: none;
    font-size: 13px;
    line-height: 23px;
    margin: 0;
    padding: 0 10px;
    cursor: pointer;
    border-width: 1px;
    border-style: solid;
    -webkit-border-radius: 3px;
    -webkit-appearance: none;
    border-radius: 3px;
    white-space: nowrap;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background: #f3f3f3;
    background-image: -webkit-gradient(linear,left top,left bottom,from(#fefefe),to(#f4f4f4));
    background-image: -webkit-linear-gradient(top,#fefefe,#f4f4f4);
    background-image: -moz-linear-gradient(top,#fefefe,#f4f4f4);
    background-image: -o-linear-gradient(top,#fefefe,#f4f4f4);
    background-image: linear-gradient(to bottom,#fefefe,#f4f4f4);
    border-color: #bbb;
    color: #333;
    text-shadow: 0 1px 0 #fff;
  }
  .cookie-notice .btn-revoke.wordpress:hover{
    background: #f3f3f3;
    background-image: -webkit-gradient(linear,left top,left bottom,from(#fff),to(#f3f3f3));
    background-image: -webkit-linear-gradient(top,#fff,#f3f3f3);
    background-image: -moz-linear-gradient(top,#fff,#f3f3f3);
    background-image: -ms-linear-gradient(top,#fff,#f3f3f3);
    background-image: -o-linear-gradient(top,#fff,#f3f3f3);
    background-image: linear-gradient(to bottom,#fff,#f3f3f3);
    border-color: #999;
    color: #222;
  }
  .cookie-notice .btn-revoke.bootstrap{
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
  }
  .cookie-notice .btn-revoke.bootstrap:hover{
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue